import PropTypes from 'prop-types';
import React from 'react';
import { Form } from 'react-bootstrap';
import { Question } from './Question';
import { DangerousHTMLDiv } from '../DangerousHTML/DangerousHTMLDiv';
import { RadioCheckboxOtherOption } from './RadioCheckboxOtherOption';
import { FormattedMessage } from 'react-intl';
import { SharedFormMessages as messages } from '../../shared/forms';

export class RadioCheckboxQuestion extends React.Component {
  constructor() {
    super();
    this.state = {
      selectedListAnswerId: null,
    };
  }

  onRadioCheckboxChange = (event) => {
    let val = event.target.value;
    if (!isNaN(val)) {
      val = parseInt(event.target.value, 10);
    }
    this.onChange(val, '', event.target.checked);
  }

  onChange = (listAnswerId, otherOptionText, isChecked) => {
    this.setState({ selectedListAnswerId: listAnswerId });
    this.props.updateAnswer(
      this.props.questionnaireItem.questionnaireItemId,
      {
        listAnswerId,
        otherOptionText,
        isChecked,
      });

    if (this.props.questionnaireItem.isValid === false) {
      this.props.validateQuestionnaire();
    }
  }

  render = () => {
    const { questionnaireItem, answerItem } = this.props;
    const invalidQuestionId = 'question_is_invalid_' + questionnaireItem.questionNumber;
    return (
    <div data-qa-item={this.props.inputType + '_question_type'} className="question-area">
      <Question questionNumber={questionnaireItem.questionNumber}
        isValid={ questionnaireItem.isValid }
        formattedText={questionnaireItem.formattedText}
        isRequired={questionnaireItem.isRequired}
      />
      <div className={questionnaireItem.isValid === false ? "form-group is-invalid": "form-group"}>
        { questionnaireItem.listAnswers.map((answer) => {
          if (answer.isOtherOption) {
            return (<RadioCheckboxOtherOption key={answer.listAnswerId}
              questionnaireItem={this.props.questionnaireItem} inputType={this.props.inputType}
              answer={answer} onChange={this.onChange}
              selectedListAnswerId={this.state.selectedListAnswerId}
              answerItem={answerItem}
              disabled={this.props.disabled}
            />);
          }
          return (
          <div className="form-check" key={answer.listAnswerId}>
            <label className="form-check-label">
                  <input className="form-check-input" type={this.props.inputType} onChange={this.onRadioCheckboxChange}
                    name={'optionsRadioCheckbox' + questionnaireItem.questionnaireItemId}
                    value={answer.listAnswerId}
                    checked={answerItem && answerItem.some(x => x.listAnswerId === answer.listAnswerId)}
                    disabled={this.props.disabled}
                  />
                  <DangerousHTMLDiv html={answer.formattedText} className="form-check-label" />
                </label>
          </div>);
        })}  
      </div>
      {
            questionnaireItem.isValid === false
              ? <span data-qa-item={ invalidQuestionId } className="invalid-feedback">
                  <FormattedMessage {...messages.error.required} />
                </span>
              : null
          }
    </div>);
  }
}

RadioCheckboxQuestion.propTypes = {
  questionnaireItem: PropTypes.object,
  updateAnswer: PropTypes.func,
  inputType: PropTypes.string,
  validateQuestionnaire: PropTypes.func,
  disabled: PropTypes.bool,
  answerItem: PropTypes.array,
};
